







































































































































































































































































































































































































































































































































































import _ from 'lodash';
import { Cell, cellNames, getColumnsRowMapObject } from '@/main/utils/table';
import { editFactory, ListLoadBehavior } from '@/main/pages';
import { openEdit, openList, openSelectList } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { CREATE, TABLE_DATA } from '@/main/store/listEditTypes';
import { editMutations as ozakazkaEditMutations } from '@/modules/servis/ozakazka/store/types';
import { editMutations as checkinEditMutations } from '@/modules/servis/checkIn/store/types';
import { NAME as CHECKIN } from '@/modules/servis/checkIn/constants';
import { NAME as OZAKAZKA_NAME } from '@/modules/servis/ozakazka/constants';
import { GDPR } from '@/modules/kartoteka/gdpr';
import { printButton, previewButton, saveButton, deleteButton } from '@/main/utils/tableOperations';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import CreateModal from '@/modules/servis/zakazka/components/CreateModal.vue';
import { showAlert } from '@/main/utils/notifications';
import { forceFileDownload, validateFiletype } from '@/main/utils/fileHelper';
import { objectToCamelCaseShallow } from '@/main/utils/stringHelper';
import { UserRole, FILE_TYPE, MAXIMUM_FILE_SIZE, ScreenSize, CustomerVehicleRefresh } from '@/main/components/constants';
import { PARTNER_TYPE } from './store/types';


import DropButtons from '@/modules/servis/zakazka/components/DropButtons.vue';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';
import { PdfProvider } from '#services/pdfProvider';

import { NAME as ZAKAZNIK_PRODEJCE } from '../zakaznikProdejce/constants';
import { NAME as VOZIDLO } from '../vozidlo/constants';
import { NO_TAX, REGULAR_TAX } from './constants';
import {
	MSG_LOG, NAME, OBRAT_TYPE, Staty, DUPLICITY_CHECK, GDPR_LOG, GDR_RESULT, SOUHLAS_MARK, ZPRACOVOSDAT_ID, NESOUHLAS, CUSTOMER_HISTORY,
	CUSTOMER_FILES, PARTNER_COMMUNICATION_MODE, VerifiedMode, ZAKAZNIK_CDB, MENU_CODE, TAB_NAMES, TABS,CDB_CUSTOMER_DEFAULTVALUE,VIN_LAST_SIX_CHARS, RETAIL_CUSTOMER_TYPE, DEFAULT_CORPORATE_CUSTOMER_TYPE,
	CUSTOMER_TYPE_INDIVIDUAL,CUSTOMER_TYPE_ORGANIZATION,DEFAULT_CUSTOMER_TYPE_INDIVIDUAL_VALUE,DEFAULT_CUSTOMER_TYPE_CORPORATE_VALUE,DEFAULT_CATEGORY_TYPE_FOR_COMPANY,
	DEFAULT_SALUTATION_MRANDMRS, SEARCHINCDB_CUSTOMERSCREEN
} from './constants';
import { gdprTiskUrl, apiProvider } from './api';
import { store } from './store/edit';
import { editMutations } from './store/types';
import PartnerSelect from './components/Select.vue';
import SmsEmailModal from '../smsEmailModal/SmsEmailModal.vue';
import { EMAIL_TYP_PZN, SMS_TYP_PZN } from '../smsEmailModal/constants';
import { apiProvider as smsEmailApiProvider } from '../smsEmailModal/api';
import AresDialog from './components/AresDialog.vue';

export default editFactory(NAME, store).extend({
	components: {
		AresDialog,
		SmsEmailModal,
		CreateModal,
		PartnerSelect,
		DmsPdfDialog,
		PracovnikSelect: Pracovnik.components.Select,
		DropButtons,
	},
	props: {
		fromMerge: { type: Boolean, default: false },
		UpdatedCustomerData: { type: Object, default: () => { } },
	},
	data() {
		return {
			lstContactButtons: [
				{ labelKey: '' as string | null, click: '' as string | null, disable: '' as string | boolean | null, exist: true as boolean | null, icon: '' as string | null },
			],
			screenSize: ScreenSize.TABLET,
			windowWidth: window.innerWidth,
			fileList: [] as any[],
			saveButton,
			deleteButton,
			isDeleteDialogVisible: false as boolean | null,
			selectedMessageId: 0,
			printButton,
			previewButton,
			zpracovosDatId: null as number | null,
			showTiskDialog: false,
			showDialog: false,
			dialogAres: {
				visible: false,
			},
			gdprTiskUrl,
			rowGDPRMark: '',
			rowGDPR: [],
			dependencies: {
				[GDPR.name]: GDPR.name,
				GDPR_LOG,
				MSG_LOG,
				DUPLICITY_CHECK,
				CUSTOMER_HISTORY,
				CUSTOMER_FILES,
			},
			emailTypPzn: EMAIL_TYP_PZN.ZAKAZNIK,
			smsTypPzn: SMS_TYP_PZN.ZAKAZNIK,
			visibleSmsEmailModal: false,
			GDR_RESULT,
			otp: null as number | null,
			isMobileDeActivate: false,
			isActionTaken: false as boolean | null,
			visibleSaveButton: true,
			CheckBoxMargin: 'chk-bx-mgn',
			tabNames: TAB_NAMES,
		};
	},
	computed: {
		aresFilter(): { ZakaznikId: number | null; Ico: string | null; Dic: string | null, StatId: number | null } {
			return {
				ZakaznikId: this.ZakaznikId,
				Ico: this.IcoNr,
				Dic: this.DicNr,
				StatId: this.StatId,
			};
		},
		duplicityTitle(): string {
			return this.LocalizePopisostatni('CielZakaznikHodnoty');
		},
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(MENU_CODE, TABS.FinanceDalsi)) tabItems.push(TAB_NAMES.FINANCEDALSI);
			if (this.hasTabAccess(MENU_CODE, TABS.MsgLog)) tabItems.push(TAB_NAMES.MSGLOG);
			if (this.hasTabAccess(MENU_CODE, TABS.ReferencePrilohy)) tabItems.push(TAB_NAMES.REFERENCEPRILOHY);
			if (this.hasTabAccess(MENU_CODE, TABS.SystemoveUdaje)) tabItems.push(TAB_NAMES.SYSTEMOVEUDAJE);
			if (this.hasTabAccess(MENU_CODE, TABS.PoznamkaOznameni)) tabItems.push(TAB_NAMES.POZNAMKAOZNAMENI);
			if (this.hasTabAccess(MENU_CODE, TABS.UpdatedCustomerDetails)) tabItems.push(TAB_NAMES.UPDATEDCUSTOMERDETAILS);
			if (!this.isFirma && this.zakaznikExists && this.hasTabAccess(MENU_CODE, TABS.Gdpr)) tabItems.push(TAB_NAMES.GDPR);

			return _.pick(TABS, tabItems);
		},
		isInfoVisible(): boolean {
			return (this.pracovnik.PracovnikOzn === UserRole.CALL_CENTER && (this.UpdatedCustomerData.IsCustomerNameUpdated || this.UpdatedCustomerData.IsCustomerEmailUpdated
				|| this.UpdatedCustomerData.IsCustomerAddressUpdated || this.UpdatedCustomerData.IsCustomerMobileNumberUpdated));
		},
		pscMask(): string | null {
			return ([Staty.CeskaRepublika, Staty.SlovenskaRepublika] as number[]).includes(this.StatId!) ? '### ##' : null;
		},
		mutationsMappers(): Record<string, string> {
			return {
				jinyPlatce: `${this.storeUri}/${editMutations.PARTNER_JINY_PLATCE_SELECT_MAPPER}`,
				matFirm: `${this.storeUri}/${editMutations.PARTNER_MAT_FIRM_SELECT_MAPPER}`,
				pracovnik: `${this.storeUri}/${editMutations.PARTNER_PRACOVNIK_SELECT_MAPPER}`,
			};
		},
		isFirma(): boolean {
			return this.PartnertypPzn === 2;
		},
		isValidTel(): boolean {
			return (!!this.TelmobNr || !!this.TelfmaNr || !!this.TelprivNr);
		},
		isCommunicationModeValid(): boolean {
			if (this.dmsSys.IsCommMode_IsDocConf_Prp) {
				if (this.CommunicationModeId === PARTNER_COMMUNICATION_MODE.EMAIL && !(this.EMailAdresa)) {
					this.CommunicationModeId = PARTNER_COMMUNICATION_MODE.NO_COMMUNICATION;
					this.showErrorAlert({ message: 'COMMUN_MODE_EMAIL' });
					return false;
				}
				if ((this.CommunicationModeId === PARTNER_COMMUNICATION_MODE.MOBILE || this.CommunicationModeId === PARTNER_COMMUNICATION_MODE.PMOBILE) && !this.isValidTel) {
					this.CommunicationModeId = PARTNER_COMMUNICATION_MODE.NO_COMMUNICATION;
					this.showErrorAlert({ message: 'COMMUN_MODE_MOBILE' });
					return false;
				}
				if (!!this.EMailAdresa || this.isValidTel) {
					return false;
				}

				this.CommunicationModeId = PARTNER_COMMUNICATION_MODE.NO_COMMUNICATION;
				return true;
			}
			this.CommunicationModeId = PARTNER_COMMUNICATION_MODE.NO_COMMUNICATION;
			return true;
		},
		zakaznikExists(): boolean {
			return this.ZakaznikId! > 0;
		},
		gdprTiskFilter(): { Id: number; PrintDialog: boolean; ReportType: string, ZpracovostdatId: number | null } {
			return {
				Id: this.ZakaznikId!,
				PrintDialog: true,
				ReportType: 'pdf',
				ZpracovostdatId: this.zpracovosDatId,
			};
		},
		selectedMessageText(): string | null {
			const selectedRow = _(this.dependentTables.MsgLog.rows).find((row) => row.cells[this.idColumn] === this.selectedMessageId);
			// 9 column is the one with message text. This magic number is not expected to be changed in current (21st) century,
			// and getting it from scheme (from backend) would complicate this code much more than a little magic constant
			return selectedRow && selectedRow.cells[8];
		},
		selectedMessageContact(): string | null {
			const selectedRow = _(this.dependentTables.MsgLog.rows).find((row) => row.cells[this.idColumn] === this.selectedMessageId);
			return selectedRow && selectedRow.cells[9];
		},
		idColumn(): number {
			return cellNames(this.dependentTables.MsgLog).idColumn;
		},
		isFromOzakazka(): boolean {
			const uri = this.ancestorUri(3);
			return !!uri && uri.includes(OZAKAZKA_NAME);
		},
		contactButtons(): object {
			this.lstContactButtons = [
				{ labelKey: 'ChangeToFO', click: 'ChangeToFO', disable: false, exist: this.isFirma && this.zakaznikExists && !this.isViewMode, icon: '' },
				{ labelKey: 'ChangeToFirma', click: 'ChangeToFirma', disable: false, exist: !this.isFirma && this.zakaznikExists && !this.isViewMode, icon: '' },
				{ labelKey: 'cmdSMSEmail', click: 'visibleSmsEmailModalForDD', disable: false, exist: this.zakaznikExists, icon: '' },
				{ labelKey: 'SEND_OTP', click: 'sendOTP', disable: false, exist: this.zakaznikExists, icon: '' },
				{ labelKey: 'VERIFY_OTP', click: 'verifyOTP', disable: false, exist: this.zakaznikExists, icon: '' },
				{ labelKey: 'cmdFindCdb', click: 'zakaznikCDB', disable: false, exist: true, icon: 'el-icon-search' },
				{ labelKey: 'REFRESH', click: 'getCustomerDetail', disable: false, exist: this.zakaznikExists, icon: '' },
			];
			return this.lstContactButtons
				.filter((item) => (item?.labelKey !== undefined && item?.labelKey != null && item.exist))
				.map((item) => ({
					labelKey: item?.labelKey,
					click: () => { this.call(item?.click); },
					exist: item?.exist,
					disable: item?.disable,
					icon: item?.icon,
				}));
		},
		isTabletEnabled(): boolean {
			return this.windowWidth > this.screenSize || _.size(this.contactButtons) === 1;
		},
	},
	watch: {
		Text(val) {
			this.titleDetail = val;
		},
		edit: {
			deep: true,
			handler() {
				if (this.ZakaznikId !== null && this.ZakaznikId !== -1 && !this.isMobileDeActivate) {
					this.isTextchanged = true;
					this.visibleSaveButton = false;
				}
			},
		},
	},
	mounted() {
		window.addEventListener('resize', () => {
			this.windowWidth = window.innerWidth;
		});
	},
	methods: {
		isForeignAmabassador(){
			if(this.IsForeignAmbassador){
				this.VatId = NO_TAX;
			}else{
				this.VatId = REGULAR_TAX;
			}
		},
		visibleSmsEmailModalForDD() {
			this.visibleSmsEmailModal = true;
		},
		call(method: any) {
			if (method === 'sendOTP') { this.sendOTP(); } else if (method === 'verifyOTP') { this.verifyOTP(); } else {
				(this as { [key: string]: any })[method];
			}
		},
		selectGdprRow(row: any): void {
			this.rowGDPRMark = row[SOUHLAS_MARK];
			this.rowGDPR = row;
		},
		onCommModeSelection() {
			if (this.CommunicationModeId === PARTNER_COMMUNICATION_MODE.EMAIL && !(this.EMailAdresa)) {
				this.showErrorAlert({ message: 'COMMUN_MODE_EMAIL' });
			} else if (
				(this.CommunicationModeId === PARTNER_COMMUNICATION_MODE.MOBILE || this.CommunicationModeId === PARTNER_COMMUNICATION_MODE.PMOBILE)
				&& !(this.isValidTel)) this.showErrorAlert({ message: 'COMMUN_MODE_MOBILE' });
		},
		async changeGdprStatus(newVal: string) {
			if (newVal === this.rowGDPR[SOUHLAS_MARK] || _.isNil(newVal)) {
				return;
			}
			if (this.isCreateMode) {
				const resp = await this.changeToEdit();
				if (resp instanceof Error) {
					this.rowGDPRMark = this.rowGDPR[SOUHLAS_MARK];
					return;
				}
			}
			if (newVal === NESOUHLAS) {
				const questionResult = await this.showConfirm({
					message: this.LocalizeChyboveHlasky('cmbOsData_zde_pznChange'),
					options: {
						confirmButtonText: this.Localize('Ano'),
						cancelButtonText: this.Localize('Ne'),
					},
				});
				if (!questionResult) {
					this.rowGDPRMark = this.rowGDPR[SOUHLAS_MARK];
				} else {
					this.setGDPR(newVal);
				}
			} else {
				this.setGDPR(newVal);
			}
		},
		async setGDPR(newVal: string) {
			await apiProvider.setGdprSouhlas({
				osdataZdePzn: newVal === NESOUHLAS ? 0 : 1,
				zakaznikId: this.ZakaznikId,
				zpracovosdatId: this.rowGDPR[ZPRACOVOSDAT_ID],
			});
			await this.refreshTable(GDPR.name);
		},
		onMergeZakaznikChange(data: any) {
			const mutation = this.isFromOzakazka ? ozakazkaEditMutations.SAVE_OZAKAZKA_AFTER_MERGE : checkinEditMutations.UPDATE_CHECKIN_AFTER_MERGE;
			return this.$store.commit(`${this.ancestorUri(3)}/${mutation}`, data);
		},
		async approveUserDetailsRequest() {
			this.startLoading();
			this.isActionTaken = true;
			const result = await apiProvider.approveDetails(this.UpdatedCustomerData);
			if (result instanceof Error) {
				this.endLoading();
			}
			await this.refreshTable(CUSTOMER_HISTORY);
			this.endLoading();
			showAlert({
				message: this.LocalizeChyboveHlasky('ApproveRec'),
				title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
				options: { type: 'info' },
			});
		},

		async rejectRequest() {
			const isValid = await this.showConfirmPokracovat('DelReq');
			if (isValid) {
				this.isDeleteDialogVisible = false;
				if (this.UpdatedCustomerData.Remarks === null) {
					showAlert({
						message: this.LocalizeChyboveHlasky('RejectRmk'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
				} else {
					this.startLoading();
					this.isActionTaken = true;
					await apiProvider.rejectDetails(this.UpdatedCustomerData);
					await this.refreshTable(CUSTOMER_HISTORY);
					this.endLoading();
					showAlert({
						message: this.LocalizeChyboveHlasky('RejectRec'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
				}
			}
		},
		async savePartner() {
			this.startLoading();
			if (this.isTextchanged === true) {
				this.visibleSaveButton = true; // Filtering the Otp condition as sms service not yet implemented
				if (this.isEditMode && !this.visibleSaveButton) {
					const message = this.LocalizeChyboveHlasky('InputOTP');
					this.visibleSaveButton = false;
					showAlert({
						message,
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
					this.endLoading();
				} else {
					await this.SavePartnerData();
					this.endLoading();
					this.otp = null;
				}
			} else {
				await this.SavePartnerData();
				this.endLoading();
				this.otp = null;
			}
		},

		async SavePartnerData() {
			let result;
			const isValid = await apiProvider.validateGSTINAndPAN(this.Pan, this.GSTIN, this.ZakaznikId!);
			if (isValid.data) {
				if (this.NarozeniDat !== null) this.NarozeniDat = new Date(this.NarozeniDat!);
				if (this.WeddingAnniversary !== null) this.WeddingAnniversary = new Date(this.WeddingAnniversary!);
				if (this.ZakaznikId !== null && this.ZakaznikId !== -1) {
					const partner: any = await apiProvider.getPartner(this.ZakaznikId);
					await this.createPartnerData(partner);
					this.showDialog = false;
					this.startLoading();
					if (partner?.headers) {
						try {
							result = await this.save();
							if (this.isChangeRequestInitialed()) {
								showAlert({
									message: this.LocalizeChyboveHlasky('ChangeReqRaised'),
									title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
									options: { type: 'info' },
								});
							}
						} finally {
							this.endLoading();
						}
					}
				} else {
					try {
						result = await this.save();
						if (this.isChangeRequestInitialed()) {
							showAlert({
								message: this.LocalizeChyboveHlasky('ChangeReqRaised'),
								title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
								options: { type: 'info' },
							});
						}
					} finally {
						this.endLoading();
					}
				}
			} else {
				showAlert({
					message: this.LocalizeChyboveHlasky('PANGSTIN'),
					title: this.LocalizeChyboveHlasky('errorTitle'),
					options: { type: 'info' },
				});
			}

			if (this.isCreateMode && this.isFromMerge && result.headers) {
				await this.onMergeZakaznikChange({
					ZakaznikId: Number(result.headers.location.split('=')[1]),
					Text: this.Text,
					Jmeno: this.Jmeno,
				});
			} else if (this.isFromMerge && this.isEditMode) {
				await this.onMergeZakaznikChange({
					ZakaznikId: this.ZakaznikId,
					Text: this.Text,
					Jmeno: this.Jmeno,
				});
			} else if (this.parentUri && this.parentUri.includes(CHECKIN)) {
				this.$store.commit(`${this.parentUri}/${checkinEditMutations.UPDATE_CHECKIN_AFTER_MERGE}`, {
					ZakaznikId: Number(result.headers.location.split('=')[1]),
					Text: this.Text,
					Jmeno: this.Jmeno,
				});
			}
		},
		async saveClick() {
			if(this.isEditMode  && this.VatId === 0 && this.IsForeignAmbassador != true){
					if(this.dependentTables.CustomerFiles.rows.length === 0 ){
					showAlert({
						message: this.LocalizeChyboveHlasky('NEED_TO_UPLOAD_DOC'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
				}
			}
			if(this.isCreateMode  && this.VatId === 0){
					showAlert({
						message: this.LocalizeChyboveHlasky('REQ_DOC_FOREIGN_AMBASSADOR'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
			}
			if (this.validateGSTIN()) {
				if (this.isCreateMode) {
					await this.fetchTableData([DUPLICITY_CHECK]);
					if (this.dependentTables.Duplicity.rows.length > 0) {
						this.showDialog = true;
					} else {
						this.savePartner();
					}
				} else {
					this.savePartner();
				}
			}
		},
		validateGSTIN() {
			if (this.GSTIN === '' && this.Pan === '') {
				return true;
			}
			if (this.GSTIN !== null && this.Pan === '') {
				this.showErrorAlert({ message: 'PANNUMBER' });
				return false;
			}
			if (this.GSTIN !== null && this.GSTIN !== '') {
				const substr = this.GSTIN.substr(2, 10);
				if (this.Pan !== substr) {
					this.showErrorAlert({ message: 'InvalidGSTIN' });
					return false;
				}
				if (this.StatId !== null) {
					const gstStateCode = Number(this.GSTIN.substr(0, 2));
					if (this.StatId !== gstStateCode) {
						this.showErrorAlert({ message: 'InvalidGSTIN' });
						return false;
					}
				}
			}
			return true;
		},
		async createApiStoreFetch(goBack = true) {
			if (this.isFromMerge && this.isCreateMode) {
				const resp = await this.$store.dispatch(`${this.storeUri}/${CREATE}`, { goBack });
				const zakaznikId = resp.headers.location.split('=')[1];
				await this.onMergeZakaznikChange({
					ZakaznikId: zakaznikId,
					Text: this.Text,
					Jmeno: this.Jmeno,
				});
				return resp;
			}
			return this.$store.dispatch(`${this.storeUri}/${CREATE}`, { goBack });
		},
		loadedData() {
			if (this.Oznam) {
				showAlert({
					message: this.Oznam,
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			}
			if (!this.isFirma && this.isEditMode) {
				(this.validationRules! as { Jmeno: { required: boolean } }).Jmeno.required = true;
			}
			if (this.fromMerge) {
				this.zakznikKonMerge(this.UpdatedCustomerData);
			}
			if (this.isCreateMode && this.KontoNr === null) {
				this.generateKontoNr();
			}
			this.setDefaultSelectedMessage();

			if (this.isViewMode && this.isInfoVisible) {
				this.activeTabName = 'UpdatedCustomerDetails';
				showAlert({
					message: this.LocalizeChyboveHlasky('AlertReqRaised'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
			}
			if (this.isViewMode && this.isInfoVisible) {
				this.activeTabName = 'UpdatedCustomerDetails';
			}

			if(this.isCreateMode){
				this.Text = this.props.name;
				const TitulId = this.dropdownList.TitulId.filter((item:any)=> item.Text == this.props.salutation);
				if(TitulId.length > 0)
				{
					this.TitulId = TitulId[0]["Value"];
					this.KategOzn = TitulId[0]["Value"];
				}
				this.NarozeniDat = this.props.birthDate;
				this.Ulice = this.props.billingStreet;
				this.Obec = this.props.billingCity;
				this.PscNr = this.props.postalCode;
				this.getStateByCode(this.props.billingCountry);
				this.TelfmaNr = this.props.dmsPhone !== null && this.props.dmsPhone.includes('-') ? this.props.dmsPhone.replace(/-/g,"") : this.props.dmsPhone;
				this.FaxNr = this.props.dmsFax;
				this.TelmobNr = this.props.dmsMobile !== null && this.props.dmsMobile.includes('-') ? this.props.dmsMobile.replace(/-/g,"") : this.props.dmsMobile;
				this.EMailAdresa = this.props.dmsEmail;
				this.CustomertypeId = RETAIL_CUSTOMER_TYPE;
				this.GoldenAccountId = this.props.goldenAccountId;
				this.CustomerInsertSource = this.props.customerInsertSource;
				this.PlatbaPzn = CDB_CUSTOMER_DEFAULTVALUE;
				this.ZakaznikSk = CDB_CUSTOMER_DEFAULTVALUE;
				this.VIN = this.props.vin;
				this.IsSearchInCDBFlag = true;
				if(this.props.accountRecordType != null && this.props.accountRecordType != undefined)
					this.PartnertypPzn = this.props.accountRecordType.replace(/\s/g, "").toUpperCase() == CUSTOMER_TYPE_INDIVIDUAL ? DEFAULT_CUSTOMER_TYPE_INDIVIDUAL_VALUE : DEFAULT_CUSTOMER_TYPE_CORPORATE_VALUE;
				if(this.PartnertypPzn === DEFAULT_CUSTOMER_TYPE_CORPORATE_VALUE) {
					this.KategOzn = DEFAULT_CATEGORY_TYPE_FOR_COMPANY;
					this.CustomertypeId = DEFAULT_CORPORATE_CUSTOMER_TYPE;
				}
				this.getDropdownForCustomerTypes(this.PartnertypPzn);
				if (this.dropdownList.KategOzn.filter((item:any)=> item.Value == this.KategOzn)?.length <= 0)
				{
					const newCustCategory =  this.dropdownList.KategOzn.filter((item:any)=> item.Text == this.props.salutation)[0];
					if (newCustCategory != undefined) {
						this.KategOzn = newCustCategory["Value"];
					}
				}
				if (this.KategOzn === null || this.KategOzn === undefined || this.KategOzn === 0 || this.dropdownList.KategOzn.filter((item:any)=> item.Value == this.KategOzn)?.length <= 0) {
					if(this.PartnertypPzn === DEFAULT_CUSTOMER_TYPE_INDIVIDUAL_VALUE)
						this.KategOzn = DEFAULT_SALUTATION_MRANDMRS;
					else
					    this.KategOzn = DEFAULT_CATEGORY_TYPE_FOR_COMPANY;
				}
				this.ContactDetails = this.props.contactDetails || [];
				this.EditDat = this.props.goldenAccountLastModified;
			}
		},
		messageSelected(cells: Cell[]) {
			this.selectedMessageId = cells[this.idColumn];
		},
		setDefaultSelectedMessage() {
			if (this.dependentTables.MsgLog.rows[0]) {
				this.selectedMessageId = this.dependentTables.MsgLog.rows[0].cells[cellNames(this.dependentTables.MsgLog).idColumn];
			}
		},
		async gdprPrint(e: Event, cells: Cell[]) {
			[this.zpracovosDatId] = cells;
			const pdfProvider = new PdfProvider(gdprTiskUrl);
			await pdfProvider.fetch(this.gdprTiskFilter);
			pdfProvider.print();
		},
		async customerFilesDownload(e: Event, cells: Cell[]) {
			const MappedRow = getColumnsRowMapObject(this.dependentTables.CustomerFiles.columns, cells) as any;
			this.startLoading();
			const file = await apiProvider.getDocuments(MappedRow.FILE_ID);
			const url = `data:application/octet-stream;base64,${file.data}`;
			forceFileDownload(url, MappedRow.FILE_NAME);
			this.endLoading();
		},
		async getDropdownForCustomerTypes(customerType : number | null){
			const { data } = (customerType === DEFAULT_CUSTOMER_TYPE_INDIVIDUAL_VALUE) ? await apiProvider.getIndividualCustomerType() : await apiProvider.getCorporateCustomerType();
			this.dropdownList.CustomertypeId = data;
		},
		async getStateByCode(code: any )
		{
			const StatId = await apiProvider.getStateByCode(code);
			if(StatId !== null)
			{
				this.StatId = StatId.data;
			}
		},
				

		async customerFilesDelete(e: Event, cells: Cell[]) {
			await apiProvider.deleteDocuments(cells[0]);
			await this.refreshTable(CUSTOMER_FILES);
		},
		gdprPreview(e: Event, cells: Cell[]) {
			[this.zpracovosDatId] = cells;
			this.showTiskDialog = true;
		},
		openCreateModalZakazka() {
			this.$refs.createModal && (this.$refs.createModal as any).createClickFun();
		},
		openVozidloPocDetail() {
			openList(VOZIDLO, {
				filter: { ZakaznikId: this.ZakaznikId, ZakaznikIdText: `${this.Text} ${this.Jmeno}` },
				listLoadBehavior: ListLoadBehavior.HIDE_FILTER,
			});
		},
		async customValidation() {
			let isValid = true;
			if (!this.TelmobNr && !this.TelfmaNr && !this.TelprivNr) {
				isValid = await this.showConfirmPokracovat('ZadnyTel');
			}
			return isValid;
		},
		openVozidloPocCreate() {
			openEdit(VOZIDLO, PageMode.CREATE, { props: true, filter: { ZakaznikId: this.ZakaznikId } });
		},
		generateKontoNr() {
			apiProvider.kontoNr().then(({ data }) => {
				this.KontoNr = data;
			});
		},
		obratMaterialClick() {
			this.openPartnerObrat(OBRAT_TYPE.MATERIAL);
		},
		obratSluzbyClick() {
			this.openPartnerObrat(OBRAT_TYPE.SLUZBY);
		},
		obratCelkovyClick() {
			this.openPartnerObrat(OBRAT_TYPE.CELKEM);
		},
		openPartnerObrat(obratType: OBRAT_TYPE) {
			openList(obratType, { filter: { ZakaznikId: this.ZakaznikId }, type: obratType });
		},
		prodejceClick() {
			openList(ZAKAZNIK_PRODEJCE, { filter: { ZakaznikId: this.ZakaznikId } });
		},
		async ChangeToFO() {
			await apiProvider.ChangeToFO(this.ZakaznikId!);
			this.resetStore();
			this.loadData();
		},
		async ChangeToFirma() {
			await apiProvider.ChangeToFirma(this.ZakaznikId!);
			this.resetStore();
			this.loadData();
		},
		onEmailSmsSend() {
			this.$store.dispatch(`${this.storeUri}/${MSG_LOG}_${TABLE_DATA}`, { filter: { ZakaznikId: this.ZakaznikId } });
		},
		isChangeRequestInitialed() {
			let isDetailsUpdated = false;
			if (!this.isCreateMode) {
				if (this.UpdatedCustomerData.EmailAdresaOld !== this.UpdatedCustomerData.NewEmailAddress || this.UpdatedCustomerData.TelmobNrOld !== this.UpdatedCustomerData.TelmobNrNew
					|| this.UpdatedCustomerData.JmenoOld !== this.UpdatedCustomerData.JmenoNew || this.UpdatedCustomerData.TextOld !== this.UpdatedCustomerData.TextNew
					|| this.UpdatedCustomerData.ObecOld !== this.UpdatedCustomerData.ObecNew || this.UpdatedCustomerData.PscNrOld !== this.UpdatedCustomerData.PscNrNew
					|| this.UpdatedCustomerData.UliceOld !== this.UpdatedCustomerData.UliceNew || (this.UpdatedCustomerData.StatIdNew !== this.UpdatedCustomerData.StatIdOld)) {
					isDetailsUpdated = true;
				}
			}
			return isDetailsUpdated;
		},
		async createPartnerData(partner: any) {
			this.UpdatedCustomerData.ZakaznikId = this.ZakaznikId;
			this.UpdatedCustomerData.TextNew = this.Text;
			this.UpdatedCustomerData.JmenoNew = this.Jmeno;
			this.UpdatedCustomerData.TelmobNrNew = this.TelmobNr;
			this.UpdatedCustomerData.NewEmailAddress = this.EMailAdresa;
			this.UpdatedCustomerData.UliceNew = this.Ulice;
			this.UpdatedCustomerData.ObecNew = this.Obec;
			this.UpdatedCustomerData.PscNrNew = this.PscNr;
			this.UpdatedCustomerData.StatIdNew = this.StatId;
			this.UpdatedCustomerData.VstupPracId = this.VstupPracId;
			this.UpdatedCustomerData.EditPracId = this.EditPracId;
			this.UpdatedCustomerData.VstupPracIdText = this.VstupPracIdText;
			this.UpdatedCustomerData.EditPracIdText = this.EditPracIdText;
			this.UpdatedCustomerData.TextOld = partner.data.Text;
			this.UpdatedCustomerData.JmenoOld = partner.data.Jmeno;
			this.UpdatedCustomerData.TelmobNrOld = partner.data.TelmobNr;
			this.UpdatedCustomerData.OldEmailAddress = partner.data.EMailAdresa;
			this.UpdatedCustomerData.UliceOld = partner.data.Ulice;
			this.UpdatedCustomerData.ObecOld = partner.data.Obec;
			this.UpdatedCustomerData.PscNrOld = partner.data.PscNr;
			this.UpdatedCustomerData.StatIdOld = partner.data.StatId;
			this.UpdatedCustomerData.Pan = this.Pan;
			this.UpdatedCustomerData.Gstin = this.GSTIN;
			this.UpdatedCustomerData.VatId = this.VatId;
			this.UpdatedCustomerData.VIN = this.VIN;
			this.UpdatedCustomerData.IsSearchInCDBFlag = this.IsSearchInCDBFlag;
			this.UpdatedCustomerData.VerifiedMode = null;
			if (this.isTextchanged) {
				this.UpdatedCustomerData.VerifiedMode = this.isMobileDeActivate ? VerifiedMode.OTPNotVerified : VerifiedMode.OTPVerified;
			}

			this.updatePartnerData(this.UpdatedCustomerData);
		},
		async updatePartnerData(partnerData: any) {
			this.startLoading();
			await apiProvider.updatePartnerOngoingEditData(partnerData);
			this.endLoading();
		},
		async submitUpload() {
			const validateFile = validateFiletype(this.fileList[0], MAXIMUM_FILE_SIZE, FILE_TYPE);
			if (!validateFile.result) {
				showAlert({
					message: this.LocalizeChyboveHlasky(validateFile.message),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			this.startLoading();
			const { data: isFileUpload } = await apiProvider.saveDocument(this.fileList[0], this.ZakaznikId);
			if (!isFileUpload) {
				this.endLoading();
				showAlert({
					message: this.LocalizeChyboveHlasky(validateFile.message),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			}			
			this.fileList = [];
			await this.fetchTableSchemas([CUSTOMER_FILES]);
			await this.refreshTable(CUSTOMER_FILES);
			this.endLoading();
		},
		handleChange(file: Record<string, any>) {
			this.fileList = [file];
		},
		handleRemove(file: File, fileList: []) {
			this.fileList = fileList;
		},
		async getVehicleDetails(vin : string,goldenAccountId : string){
			this.startLoading();
			const { data: response } = await apiProvider.getVehicleDetailsByVIN(this.VIN, goldenAccountId);
			this.endLoading();
			if(!response){
				showAlert({
					message: this.LocalizeChyboveHlasky('AlertMsgForVINNotFound'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
				return;
			}
			if(response.IsInValidVINData){
				showAlert({
					message: this.LocalizeChyboveHlasky('AlertMsgForInvalidVINData'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
				return;
			}
			if(response.IsVINFoundInServiceOrder){
				showAlert({
					message: this.LocalizeChyboveHlasky('AlertMsgForVINFoundInActiveServiceOrder').replace(/#VIN#/g, (m : string) => {
						if(m === '#VIN#')
							return response.KaroserieNr;
						return "";
					}),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
				return;
			}
		},
		emailChange() {
			this.isTextchanged = true;
			this.isEmailChanged = true;
			this.visibleSaveButton = false;
		},
		async getCustomerDetail() {
            if (this.ZakaznikId !== null) {
			this.startLoading();
			const { data } = await apiProvider.getCustomerByGoldenAccountId(this.ZakaznikId, null, CustomerVehicleRefresh.CUSTOMER);
			if(data ==  true)
			{
				if (this.ZakaznikId !== null && this.ZakaznikId !== -1) {
				const partner: any = await apiProvider.getPartner(this.ZakaznikId);
				this.Text = partner.data.Text;
				this.Obec = partner.data.Obec;
				this.Ulice = partner.data.Ulice;
				this.PscNr = partner.data.PscNr;
				this.TelefonNr = partner.data.TelefonNr;
				this.TelmobNr = partner.data.TelmobNr;
				this.TelfmaNr = partner.data.TelfmaNr;
				this.FaxNr = partner.data.FaxNr;
				this.EMailAdresa = partner.data.EMailAdresa;
				this.TitulId = partner.data.TitulId;
				this.GoldenAccountId = partner.data.GoldenAccountId;
				this.PlatbaPzn = partner.data.PlatbaPzn;
				this.ZakaznikSk = partner.data.ZakaznikSk;
				this.CustomertypeId = partner.data.CustomertypeId;
				this.StatId = partner.data.StatId;
				this.VatId = partner.data.VatId;
				this.showErrorAlert({
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					message: this.LocalizeChyboveHlasky('DataSyncSuccess'),
					options: { type: 'info' },
				});
				}
				
			}
			this.endLoading();
		 }
		},
		async sendOTP() {
			let messageAlert;
			const customerOtpDto = {
				zakaznikId: this.ZakaznikId,
				recepient_SMS: this.TelmobNr,
				recepient_Email: this.EMailAdresa,
			};
			this.startLoading();
			const { data: sendSms } = await smsEmailApiProvider.sendOTP(objectToCamelCaseShallow(customerOtpDto));
			if (sendSms) {
				messageAlert = this.LocalizeChyboveHlasky('OTPSent');
			} else {
				messageAlert = this.LocalizeChyboveHlasky('OTPNotSent');
			}
			this.endLoading();
			showAlert({
				message: messageAlert,
				title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
				options: { type: 'info' },
			});
		},

		async verifyOTP() {
			let messageAlert;
			if (this.otp !== null) {
				const customerOtpDto = {
					otp: this.otp,
					zakaznikId: this.ZakaznikId,
				};
				this.startLoading();
				const { data: isOTPverified } = await smsEmailApiProvider.verifyOTP(objectToCamelCaseShallow(customerOtpDto));
				this.endLoading();

				if (isOTPverified) {
					this.visibleSaveButton = true;
					messageAlert = this.LocalizeChyboveHlasky('OTPVerified');
				} else {
					this.otp = null;
					this.visibleSaveButton = false;
					messageAlert = this.LocalizeChyboveHlasky('OTPInvalid');
				}
			} else {
				this.visibleSaveButton = false;
				messageAlert = this.LocalizeChyboveHlasky('InputOTP');
			}
			this.endLoading();
			showAlert({
				message: messageAlert,
				title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
				options: { type: 'info' },
			});
		},
	},
});
